module.exports = __webpack_public_path__ + "static/media/firstFunnel-img.3c72a13e.svg";